export default __webpack_public_path__ + "static/media/SourceSansPro-Black.b6442b58.ttf";